// Deprecated
// 初期開発時に使用していた部品
// 今後は BuildingUsecaseSelect コンポーネントの multiple = false を使用してください

import { FC } from 'react'
import {
  DropDownList,
  DropDownListChangeEvent,
  DropDownListProps
} from '@progress/kendo-react-dropdowns'

import { useAppSelector } from '../../stores'
interface BuildingUsecaseDropDownListProps
  extends Omit<
  DropDownListProps,
  'data' | 'dataItemKey' | 'textField' | 'onChange'
  > {
  /** CODE */
  defaultValue?: string
  /** CODE */
  value?: string
  /**
   * @param value CODE
   */
  onChange?: (value: string) => void
  clear?: boolean
}

export const BuildingUsecaseDropDownList: FC<
BuildingUsecaseDropDownListProps
> = ({ defaultValue, value, onChange, clear = false, ...restProps }) => {
  const common = useAppSelector((x) => x.common)
  const codeNames = common.initialData.codeNames('TA02')
  if (clear) {
    codeNames.unshift({ CODE: '', NAME: '' })
  }

  const createValue = (codeValue?: string) => {
    if (codeValue === undefined) {
      return null
    }

    const value = codeNames.find((codeName) => codeName.CODE === codeValue)

    return value === undefined ? null : value
  }

  const handleOnChange = (event: DropDownListChangeEvent) => {
    onChange?.(event.value.CODE)
  }

  return (
    <DropDownList
      {...restProps}
      data={codeNames}
      dataItemKey="CODE"
      textField="NAME"
      defaultValue={createValue(defaultValue)}
      value={createValue(value)}
      onChange={handleOnChange}
    />
  )
}
